<script>
  import { router, navigateTo } from "yrv/build/dist";
  import Lightbox from "../Component/Lightbox.svelte";
  import OverviewButton from "../Component/OverviewButton.svelte";
  import LightboxButton from "../Component/LightboxButton.svelte";
  import Figure from "../Component/Figure.svelte";
  import { tick } from "svelte";
  import { Splide, SplideTrack, SplideSlide } from "@splidejs/svelte-splide";
  import { nanoID } from "../Api/store";
  import { rafTimeOut } from "../../Helper";

  export let overviewUrl;
  export let enableOverview = false;
  export let getLocationPath = () => {};
  export let data;

  $: lightboxOpen = false;
  let current = null;
  let items = [];

  $: if ($data) {
    items = $data.items || $data;
  }

  tick().then(() => {
    const itemId = parseInt($router.params.itemId);
    current = Number.isInteger(itemId) ? itemId - 1 : 0;
  });

  let currentImage = null;
  let currenFigure = null;
  let arrowTop = 0;
  let sliderHeight = 0;

  const paginationThreeshold = 30;
  const paginationClass = "mt-4";

  function changeHeights() {
    rafTimeOut(() => {
      arrowTop = currentImage ? parseInt(currentImage.height / 2) : 0;
      sliderHeight = currenFigure ? currenFigure.offsetHeight : 0;
    }, 200);
  }
</script>

{#if items && current !== null}
  <Splide
    aria-labelledby={`headline-${$nanoID}`}
    class="wisch__slider mb-8 overflow-hidden "
    style={`--arrow-top:${arrowTop ? `${arrowTop}px` : "50%"};--max-height:${sliderHeight ? `${sliderHeight}px` : "auto"}`}
    hasTrack={false}
    options={{
      lazyLoad: "nearby",
      preloadPages: 2,
      keyboard: !lightboxOpen && "global",
      rewind: true,
      pagination: items.length <= paginationThreeshold,
      start: current,
      classes: {
        arrow: "splide__arrow transition-all top-[var(--arrow-top,50%)] z-20",
        pagination: `splide__pagination ${paginationClass}`,
      },
      i18n: {
        pageX: "Gehe zur Seite %s",
        play: "Starte automatisches Sliden",
        pause: "Pausiere automatisches Sliden",
        slideLabel: "%s von %s",
        carousel: "Karussell",
        prev: "Gehe zur vorherigen Slide",
        next: "Gehe zur nächsten Slide",
        first: "Gehe zur ersten Slide",
        last: "Gehe zur letzten Slide",
        slideX: "Gehe zur Slide %s",
        select: "Selektiere eine Slide zum zeigen",
      },
    }}
    on:resize={changeHeights}
    on:active={({ detail }) => {
      const data = detail.Slide;
      current = data.index;
      const currentSlide = data.slide;
      currenFigure = currentSlide.querySelector("figure");
      currentImage = currenFigure.querySelector("img");
      changeHeights();
      navigateTo(getLocationPath(current), { replace: true });
    }}
  >
    <SplideTrack class="z-10 max-h-[var(--max-height)] transition-all">
      {#each items as item}
        <SplideSlide>
          <Figure {item} />
        </SplideSlide>
      {/each}
    </SplideTrack>
    <OverviewButton overviewUrl={enableOverview && overviewUrl} />
    <LightboxButton bind:lightboxOpen />
    {#if items.length > paginationThreeshold}
      <p class={`flex items-center justify-center ${paginationClass}`}>
        Bild {current + 1} von {items.length}
      </p>
    {/if}
  </Splide>

  <Lightbox item={items[current]} bind:visible={lightboxOpen} openKey="+" />
{/if}

<style>
  :global(.wisch__slider) {
    transition-property: max-height;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
</style>
